import { useEffect } from "react";

import { useCategoriesStore } from "../stores/CategoriesStore";
import type { HomeProductsProps } from "../types/components/HomeProductsProps";
import { HomeCallout } from "./HomeCallout";
import { OutputProducts } from "./OutputProducts";

export const HomeProducts = ({ initialHomepage = [], prefetchedProducts = [] }: HomeProductsProps) => {
	const { homepageInfo, GetHomepage } = useCategoriesStore(({ homepageInfo, GetHomepage }) => ({
		homepageInfo,
		GetHomepage,
	}));
	const resolvedHomepage = homepageInfo?.length ? homepageInfo : initialHomepage;
	const resolvedPrefetched = prefetchedProducts;

	useEffect(() => {
		if (!initialHomepage?.length) return;
		if (homepageInfo?.length) return;
		useCategoriesStore.setState({ homepageInfo: initialHomepage });
	}, [homepageInfo?.length, initialHomepage?.length]);

	useEffect(() => {
		if (resolvedHomepage?.length) return;
		GetHomepage();
	}, [GetHomepage, resolvedHomepage?.length]);

	if (!resolvedHomepage || !resolvedHomepage.length) return null;

	return (
		<div className="home-products">
			{resolvedHomepage.length ? (
				<>
					<div className="featured">
						<div className="container">
							<OutputProducts
								products={resolvedHomepage[0]}
								prefetchedProducts={resolvedPrefetched?.[0]}
								loadingAnimation={false}
								lazy={true}
								aboveFold={true}
								buyButton={true}
							/>
						</div>
					</div>

					<div className="remaining">
						<div className="container">
							<OutputProducts
								products={resolvedHomepage[1]}
								prefetchedProducts={resolvedPrefetched?.[1]}
								loadingAnimation={false}
								lazy={true}
								buyButton={true}
							/>
						</div>
					</div>
				</>
			) : null}
		</div>
	);
};
